import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import * as Utils from "../../../inc/Utils";
import Select from 'react-select'
import CampaignTemplateCreateProject from "./CampaignTemplateCreateProject";
import CampaignTemplateCreatePromotion from "./CampaignTemplateCreatePromotion";
import CampaignTemplateCreateMasterURL from "./CampaignTemplateCreateMasterURL";
import CampaignTemplateCreateSpecial from "./CampaignTemplateCreateSpecial";

export default function CampaignTemplateCreate() {

    let [type, setType] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    let [name, setName] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const resType = await Utils.getType();
                setType(resType);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const handleChange = (e) => {
        setName(e.target.value);
    };

    const onChangeTypeId = async (obj) => {
        setTypeId(obj);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Campaign Template</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Campaign Template <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" maxLength={100} onChange={handleChange} />
                            </div>

                            <div className="col-12">
                                <label htmlFor="typeIed" className="form-label">Type <span className="text-danger">*</span></label>
                                <Select
                                    classNamePrefix="form-select-search"
                                    options={type}
                                    onChange={(event) => onChangeTypeId(event)}
                                    value={typeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            {
                                typeId && typeId.id === Utils.GENERATE_TYPE_PROJECT ? <CampaignTemplateCreateProject typeId={typeId} name={name} /> : ''
                            }
                            {
                                typeId && typeId.id === Utils.GENERATE_TYPE_PROMOTION ? <CampaignTemplateCreatePromotion typeId={typeId} name={name} /> : ''
                            }
                            {
                                typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL ? <CampaignTemplateCreateMasterURL typeId={typeId} name={name} /> : ''
                            }
                            {
                                typeId && typeId.id === Utils.GENERATE_TYPE_SPECIAL ? <CampaignTemplateCreateSpecial typeId={typeId} name={name} /> : ''
                            }
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 